import * as Actions from './actions';

export const forms = (state = {}, action) => {
  switch (action.type) {
    case Actions.FORM_SUBMITTED:
      return {
        ...state,
        [action.formName]: action.form,
      };
    default:
      return state;
  }
};
